import React from "react";
import cx from "classnames";

class DialogTitle extends React.Component {
  static defaultProps = {
    baseClassName: "si-c-dialog__title",
  };

  render() {
    var { children, baseClassName, className, style } = this.props;

    return (
      <div style={style} className={cx(baseClassName, className)}>
        {children}
      </div>
    );
  }
}

export default DialogTitle;
